import { PAGE_DEFAULT, ROW_DEFAULT } from "constants/global";

export const EMPTY_DATA_SEARCH_STAFF = {
    text_search: "",
    working_status: 1,
    employee_status: null,
    organization_uuid: null,
    created_at: null,
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
};
